export default __webpack_public_path__ + "static/media/Aura-Egg__98.5fd71450.png";